export default __webpack_public_path__ + "static/media/terms-of-use.a156e764.jpg";